// extracted by mini-css-extract-plugin
export default {"root":"muEGl","search":"nnrNS","currencies":"EoBmE","item":"KkzmH","name":"laS7S","price":"ZksbW","chevron":"lf6Vq","empty":"YA5qX"};